import { useState, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ToastContainer } from '@/components/ToastContainer';
import { CompanyContextBanner } from '@/components/CompanyContextSwitcher';
import { MaintenanceBanner } from '@/components/MaintenanceBanner';
import { FullAuditBanner } from '@/components/FullAuditBanner';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useApplyTheme } from '@/lib/theme';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  useApplyTheme(pathname);

  const openSidebar = useCallback(() => setSidebarOpen(true), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main content area */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header onMenuClick={openSidebar} />

        {/* Maintenance mode banner */}
        <MaintenanceBanner />

        {/* Full-audit-mode banner (visible only when active company has auditMode === 'full') */}
        <FullAuditBanner />

        {/* Company context banner (shown when viewing as another company) */}
        <CompanyContextBanner />

        {/* Content wrapper */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-6 scrollbar-thin">
          <div className="mx-auto max-w-7xl">
            {/* Keyed by path: a page that crashes shows an error in place of the
                content (not a black screen) and navigating away clears it. */}
            <ErrorBoundary key={pathname}>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>

      <ToastContainer />
    </div>
  );
}
